<template>
  <div id="emails">
    <div class="card custom-card scroll-emails">
      <h6 class="aside-title">Emails</h6>
      <ul class="list-group activities-media" style="height: 100%" v-if="emails.length > 0">
        <EmailItem
          v-for="email in emails"
          :key="email.id"
          :currentEmail="email"
          v-on:showEmail="showCurrentEmail($event)"
        />
      </ul>
      <ErrorList v-else class="no-data-message" name="noEmails" />
    </div>
  </div>
</template>

<script>
import CustomMainModal from '../../Modals/CustomMainModal';
import SvgHelper from '../../common/svgHelper';
import { mapGetters } from 'vuex';
import EmailItem from './EmailItem.vue';
import ErrorList from '@/components/common/errorsList';

export default {
  components: {
    CustomMainModal,
    SvgHelper,
    EmailItem,
    ErrorList,
  },
  props: {
    height: {
      type: String,
      default: '865px',
    },
    emails: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    showEmailModal: false,
    currentEmail: ' ',
  }),
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.svg-icon {
  width: 15px;
  height: auto;
}

/* .activities-date {
  position: absolute;
  display: block;
  white-space: nowrap;
  right: 15px;
  color: #000;
  font-size: 13px;
} */

.candidate-aside .scroll-emails {
  height: 628px !important;
}

li {
  padding-left: 0 !important;
}

#emails {
  .card {
    margin: 0;
  }
}

/* #emails {
  h6 {
    font-size: 18px;
    font-family: $font-family-sans-serif;
  }

  .activities-media li {
    border-radius: 0 !important;
    border: 0;
  }

  .activities-media li:nth-child(odd) {
    border-left: 5px solid #f05a00;
    background-color: #f1f1f3;
  }

  .activities-media li:nth-child(even) {
    border-left: 5px solid #747674;
  }

  .activities-name {
    font-family: Lato;
    color: $color-base-blue;
    letter-spacing: 0.9px;
    margin: 0;
  }

  .activities-status-color {
    color: #f05a00;
  }
} */

.scroll-emails {
  overflow: hidden;
}

.activities-media {
  overflow-y: auto;
  figure {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    margin: 0 15px 0 10px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 0;
      object-fit: cover;
    }
  }

  p {
    margin: 0;
  }

  .activities-date {
    font-size: 13px;

    position: absolute;
    display: block;
    white-space: nowrap;
    right: 15px;
    color: #000;
    font-size: 13px;
  }
}

.modal-body {
  margin-top: 0;
  padding-top: 0;
  .list-unstyled {
    margin-bottom: 30px !important;
    li {
      border: none !important;
      padding-left: 0px !important;
    }
  }
}

.embed-emails {
  .list-unstyled {
    li {
      font-size: 15px;
      border-bottom: 1px dashed #ddd !important;
      padding: 8px 0;
      span {
        display: inline-block;
        min-width: 80px;
        font-size: 14px;
        font-weight: 700;
      }
    }
  }
  .list-unstyled.bottom {
    li {
      font-size: 14px;
      padding: 0;
      margin: 0;
      span {
        color: #111;
        font-weight: 700;
        min-width: auto;
        margin-right: 12px;
      }
    }
  }
  .views {
    max-height: 57vh;
    min-height: 57vh;
    overflow-y: auto;
    .single-email {
      padding: 20px 0px;
      margin-bottom: 12px;
      p {
        font-size: 16px;
      }
    }
  }
}
@media only screen and (max-width: 1251px) {
  .card {
    border-bottom-left-radius: 18px !important;
    border-bottom-right-radius: 18px !important;
  }
}

@media only screen and (max-width: 992px) {
  .card {
    border: none;
    border-radius: 0 !important;
    margin-top: 22px !important;
    h6 {
      display: none;
    }
  }
}

@media only screen and (max-width: 768px) {
  .card {
    border: none;
    border-radius: 0 !important;
    margin-top: 22px !important;
    h6 {
      display: none;
    }
  }
}

@media only screen and (max-width: 576px) {
  .activities-media {
    overflow: visible;
    height: auto !important;
  }
  .card {
    margin-top: 12px !important;
    border-radius: 0;
    border: none;
  }
  h6 {
    display: block !important;
  }
}
</style>
